import React from 'react'
import { Link } from '@inertiajs/react'
import { cx } from '@/lib/utils'
import styles from './TagBadge.module.scss'

interface TagBadgeProps {
  name: string
  slug: string
  active?: boolean
  basePath?: string
}

export const TagBadge: React.FC<TagBadgeProps> = ({ name, slug, active = false, basePath = '/blog' }) => (
  <Link href={active ? basePath : basePath + '?tag=' + slug} className={cx(styles.badge, active && styles.active)}>
    {name}
  </Link>
)
